module.exports = __webpack_public_path__ + "media/images/icons/unsuccess-0516318e1b6d98e8f67bf50507f64dd8.svg";